module.exports = __webpack_public_path__ + "img/share.2ea6e5dc.jpg";